import cx from "classnames";
import { memo } from "react";
import styles from "@/interface/RightSheet/Presentations/PresentationsNavigator/PresentationView/PresentationView.module.scss";
import type { DropPosition } from "@/interface/RightSheet/Presentations/PresentationsNavigator/types";

export const SlideContent = memo(
    ({
        imgSrc,
        uid,
        isSelected,
        isDragOver,
        dropPosition,
        onClick,
        onDragStart,
        onDragOver,
        onDragLeave,
        onDrop,
        isDraggable,
    }: {
        imgSrc?: string;
        uid: string;
        isSelected: boolean;
        isDragOver: boolean;
        dropPosition?: DropPosition;
        onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
        onDragStart?: (e: React.DragEvent<HTMLDivElement>) => void;
        onDragOver?: (e: React.DragEvent<HTMLDivElement>) => void;
        onDragLeave?: () => void;
        onDrop?: (e: React.DragEvent<HTMLDivElement>) => void;
        isDraggable: boolean;
    }) => (
        <div
            className={cx(styles.content, {
                [styles.dragOverAbove]: isDragOver && dropPosition === "above",
                [styles.dragOverBelow]: isDragOver && dropPosition === "below",
            })}
            onClick={onClick}
            draggable={isDraggable}
            onDragStart={onDragStart}
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
        >
            <div
                className={cx(styles.contentInner, {
                    [styles.selected]: isSelected && isDraggable,
                })}
            >
                {imgSrc ? (
                    <img src={imgSrc} draggable={false} />
                ) : (
                    <div className={styles.skeleton} />
                )}
            </div>
        </div>
    ),
);
